export default __webpack_public_path__ + "static/media/share-whiteboard.ab02addf.svg";